import React from "react";
import { Box } from "@mui/material";
import upload from "../assets/CreateJobAssest/upload-icon.svg";
import remove from "../assets/CreateJobAssest/delete-icon.svg";
import edit from "../assets/CreateJobAssest/edit-icon.svg";
import cancel from "../assets/CreateJobAssest/cancel-icon.svg";
import generate from "../assets/CreateJobAssest/generate-skills-icon.svg";
import jobDiva from "../assets/CreateJobAssest/jobdive.svg";
import techStack from "../assets/CreateJobAssest/tech-stack-icon.svg";
import resume from "../assets/CreateJobAssest/resume-icon.svg";
import allocation from "../assets/CreateJobAssest/allocation-icon.svg";
const sources = { upload, remove, edit, cancel, generate, jobDiva, techStack, resume, allocation };
export default function RecruitmentAsset({ name, sx, ...props }) {
  return <Box component="img" src={sources[name]} alt="" aria-hidden="true" {...props} sx={{ width:18, height:18, objectFit:"contain", ...sx }} />;
}
